import React from "react";
import { func, bool } from "prop-types";

import { Button, ModalHeader, ModalFooter } from "reactstrap";
import { Modal } from "@material-ui/core";
import "./saveWatchlistIgnoringPropertiesModal.css";
import { useSelector } from "react-redux";
import {
  isLoadingScoringDecisionTemplate,
  selectScoringDecisionTemplate,
} from "../../../selectors";
import FullscreenLoader from "../../../../../layouts/FullScreenLoader";
import useRoles from "../../../../../components/hooks/useRoles";
import { Field, Form, Formik } from "formik";
import FormikInput from "../../../../../components/formik/Input";
import { withError } from "../../../../../components/hocs";
import {
  commentValidationSchema,
  validateCommentOnly,
} from "./commentValidationSchema";
import FormikSelect from "../../../../../components/formik/Select";

const SaveWatchlistIgnoringPropertiesModal = ({
  isOpen,
  toggle,
  handleSubmit,
}) => {
  const { isCoordinator, isManager, isMaster } = useRoles();
  const isCoordinatorOrManager = isCoordinator || isManager || isMaster;
  const options = useSelector(selectScoringDecisionTemplate);

  return (
    <Modal open={isOpen}>
      {isCoordinatorOrManager && options.length && options.length > 1 ? (
        <RenderOnCoordinatorOrManager
          handleSubmit={handleSubmit}
          isOpen={isOpen}
          toggle={toggle}
        />
      ) : (
        <RenderOnlyComment handleSubmit={handleSubmit} toggle={toggle} />
      )}
    </Modal>
  );
};

function RenderOnCoordinatorOrManager({ isOpen, toggle, handleSubmit }) {
  const isLoading = useSelector(isLoadingScoringDecisionTemplate);
  const options = useSelector(selectScoringDecisionTemplate);
  const ErrorInput = withError(FormikInput);

  const formatOptions = (options) => {
    if (!options.length) return [];
    return options.map((option) => ({
      ...option,
      label: option.value,
      value: option.key,
    }));
  };

  const onSubmit = (values, { resetForm }) => {
    const { option, comment } = values;
    const selectedOption = getCurrentOption(option);
    if (selectedOption.forOptionalComment) {
      handleSubmit(comment);
    } else {
      handleSubmit(selectedOption.value);
    }
    resetForm();
    toggle();
  };

  function getCurrentOption(optionKey) {
    return options.find((opt) => opt.key === optionKey);
  }

  return (
    <div className="save-form-confirm-modal">
      <FullscreenLoader loading={isLoading} />
      <ModalHeader>Save Watchlist Ignoring Properties</ModalHeader>
      <Formik initialValues={{ option: "", comment: "" }} onSubmit={onSubmit}>
        {({ handleSubmit, values, isValid }) => {
          const currentOption = getCurrentOption(values.option);

          return (
            <Form>
              <div className="modal-box">
                <Field
                  name="option"
                  component={FormikSelect}
                  options={formatOptions(options)}
                  maxMenuHeight={120}
                />

                {currentOption && currentOption.forOptionalComment ? (
                  <React.Fragment>
                    <Field
                      type="textarea"
                      validate={validateCommentOnly}
                      name="comment"
                      component={ErrorInput}
                      placeholder="Enter comment"
                    />
                  </React.Fragment>
                ) : null}
              </div>
              <ModalFooter>
                <Button
                  className="save-form-confirm-modal-button cancel-button"
                  color="secondary"
                  onClick={toggle}
                >
                  Cancel
                </Button>
                <Button
                  className="save-form-confirm-modal-button confirm-button"
                  color="primary"
                  onClick={handleSubmit}
                  disabled={!isValid}
                >
                  Save
                </Button>
              </ModalFooter>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}

function RenderOnlyComment({ toggle, handleSubmit }) {
  const ErrorInput = withError(FormikInput);

  const onSubmit = ({ comment }, { resetForm }) => {
    handleSubmit(comment);
    resetForm();
    toggle();
  };

  return (
    <div className="save-form-confirm-modal">
      <ModalHeader>Save Watchlist Ignoring Properties</ModalHeader>
      <Formik
        initialValues={{ comment: "" }}
        onSubmit={onSubmit}
        validationSchema={commentValidationSchema}
      >
        {({ isValid, handleSubmit }) => {
          return (
            <Form>
              <div className="modal-box">
                <Field
                  placeholder="Enter comment"
                  type="textarea"
                  name="comment"
                  component={ErrorInput}
                />
              </div>
              <ModalFooter>
                <Button
                  className="save-form-confirm-modal-button cancel-button"
                  color="secondary"
                  onClick={toggle}
                >
                  Cancel
                </Button>
                <Button
                  className="save-form-confirm-modal-button confirm-button"
                  color="primary"
                  onClick={handleSubmit}
                  disabled={!isValid}
                >
                  Save
                </Button>
              </ModalFooter>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}

SaveWatchlistIgnoringPropertiesModal.propTypes = {
  isOpen: bool.isRequired,
  toggle: func.isRequired,
  handleSubmit: func.isRequired,
};

export default SaveWatchlistIgnoringPropertiesModal;



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/components/searching/save-watchlist-ignoring-properties-modal/SaveWatchlistIgnoringPropertiesModal.jsx